import { SpecialPermissionsLogs } from './SpecialPermissionsLogs';

export const specialPermissionsLogsRootReducer = {
  specialPermissionsLogs: SpecialPermissionsLogs,
};
